<template>
  <v-navigation-drawer
    v-if="showDrawer"
    id="app-drawer"
    v-model="inputValue"
    :mini-variant.sync="mini"
    mini-variant-width="75"
    app
    dark
    floating
    persistent
    mobile-break-point="991"
    width="260"
    hide-overlay
  >
    <v-img
      :src="image"
      height="100%"
      @mouseenter="miniMenu(false)"
      @mouseleave="miniMenu(true)"
    >
      <v-layout class="fill-height" tag="v-list" column>
        <v-list class="pl-0 pt-3" dense>
          <v-list-tile class="pa-0 pl-0" avatar>
            <v-list-tile-avatar class="pl-1 pr-0 mr-0 ml-0 pb-3" v-if="mini">
              <v-img :src="logo" height="30" class="pa-6" />
            </v-list-tile-avatar>
            <v-img v-else :src="logo" width="40" class="ma-3" />
          </v-list-tile>
        </v-list>
        <v-divider />
        <v-list dense class="pt-0 pb-0">
          <v-list-tile
            v-for="(link, i) in activeLinks"
            :key="i"
            :to="link.to"
            :active-class="color"
            avatar
            class="v-list-item pl-0 pt-0 pb-0"
          >
            <template v-if="!link.items">
              <v-list-tile-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title v-text="link.text" />
            </template>
            <!-- <template v-else>
              <v-list-tile-action>
                <v-icon>{{ link.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title v-text="link.text"/>
            </template> -->
            <v-list-group v-else no-action hover>
              <template v-slot:activator>
                <v-list-tile-action>
                  <v-icon>{{ link.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title class="pl-3" v-text="link.text" />
              </template>
              <v-list-tile
                v-for="(subItem, i) in link.items"
                :key="i"
                :to="subItem.to"
                dark
                class="v-list-item pl-0"
              >
                <v-list-tile-action>
                  <v-icon>{{ subItem.icon }}</v-icon>
                </v-list-tile-action>
                <v-list-tile-title v-text="subItem.text" />
              </v-list-tile>
            </v-list-group>
          </v-list-tile>
        </v-list>

        <v-list-tile
          active-class="primary"
          class="v-list-item v-list__tile--buy"
          @click="signOut"
        >
          <v-list-tile-action>
            <v-icon>mdi-exit-run</v-icon>
          </v-list-tile-action>
          <v-list-tile-title class="font-weight-light">Sair</v-list-tile-title>
        </v-list-tile>
      </v-layout>
    </v-img>
  </v-navigation-drawer>
</template>

<script>
// Utilities
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    logo: "../../img/logo_novo_splash.png",
    partner: "enercred",
    showDrawer: false,
    mini: true,
    links: [
      {
        to: "/dashboard",
        icon: "mdi-view-dashboard",
        text: "Dashboard",
        permission: true,
        group: ["admin", "financial", "partner", "partner_management"],
      },
      {
        to: "/atendimento",
        icon: "support",
        text: "Atendimento",
        permission: true,
        group: [
          "admin",
          "customer_care",
          "collection",
          "eletron",
          "external_collection",
        ],
      },
      /*
      {
        to: '/user-profile',
        icon: 'mdi-account',
        text: 'Minha Conta',
        permission: true,
      },
      */
      /*
      {
        to: '/table-list',
        icon: 'mdi-clipboard-outline',
        text: 'Table List'
      },
      */
      {
        to: "/leads",
        icon: "mdi-account-card-details",
        text: "Leads",
        permission: false,
        group: ["admin", "marketing"],
      },
      {
        to: "/unidades-consumidoras/",
        icon: "mdi-office-building",
        text: "Unidades Consumidoras",
        permission: false,
        group: ["admin", "customer_care", "sales"],
      },
      {
        to: "/membros",
        icon: "mdi-account-multiple",
        text: "Membros",
        permission: false,
        group: ["admin", "customer_care", "sales", "eletron"],
      },
      // {
      //   to: "/indicacoes",
      //   icon: "mdi-account-multiple",
      //   text: "Indicações",
      //   permission: false,
      //   group: ["admin"]
      // },
      {
        to: "/listas",
        icon: "list",
        text: "Listas",
        permission: true,
        group: ["admin", "financial"],
      },
      {
        // to: "/faturamento/lista",
        icon: "monetization_on",
        text: "Faturamento",
        permission: false,
        group: ["admin", "financial", "partner_management"],
        items: [
          {
            to: "/faturamento/tarifas",
            icon: "monetization_on",
            text: "Tarifas",
            permission: false,
            group: ["admin", "financial", "partner_management"],
          },
          {
            to: "/faturamento/lista",
            icon: "monetization_on",
            text: "Faturamento",
            permission: false,
            group: ["admin", "financial", "partner_management"],
          },
          // {
          //   to: "/conta-unica/lista",
          //   icon: "adjust",
          //   text: "Conta Única",
          //   permission: false,
          //   group: ["admin", "financial"]
          // }
        ],
      },
      {
        to: "/extrato",
        icon: "account_balance",
        text: "Extrato",
        permission: true,
        group: ["admin", "partner", "financial", "partner_management"],
      },
      {
        to: "/vendas",
        icon: "gavel",
        text: "Vendas",
        permission: true,
        group: [
          "admin",
          "sales",
          "sales_partner",
          "sales_management",
          "sales_partner_management",
        ],
      },
      // {
      //   to: "/qualificacao",
      //   icon: "rule",
      //   text: "Qualificação",
      //   permission: true,
      //   group: ["admin", "customer_care", "sales_management"]
      // },
      {
        icon: "psychology",
        text: "Marketing",
        permission: true,
        group: ["admin", "marketing"],
        items: [
          {
            to: "marketing/cupons",
            icon: "sell",
            text: "Cupons",
            permission: true,
            group: ["admin", "marketing"],
          },
        ],
      },
      {
        to: "/concessionaria/arquivos",
        icon: "business",
        text: "Concessionaria",
        permission: false,
        group: ["admin", "financial"],
      },
      {
        icon: "settings",
        text: "Configurações",
        permission: true,
        group: ["admin"],
        items: [
          {
            to: "/configuracao/usuarios",
            icon: "group",
            text: "Usuários",
            permission: true,
            group: ["admin"],
          },
          {
            to: "/configuracao/parceiros",
            icon: "engineering",
            text: "Parceiros",
            permission: true,
            group: ["admin"],
          },
          {
            to: "/configuracao/usinas",
            icon: "bolt",
            text: "Usinas",
            permission: true,
            group: ["admin"],
          },
        ],
      },
      // {
      //   to: "/lista_vendas",
      //   icon: "view_list",
      //   text: "Listar Vendas",
      //   permission: true,
      //   group: ["admin", "sales", "sales_partner", "sales_management"]
      // },
      // {
      //   to: "/prospects",
      //   icon: "perm_phone_msg",
      //   text: "Prospects",
      //   permission: true,
      //   group: ["admin", "sales", "sales_partner", "sales_management"]
      // },
      // {
      //   to: "/disparos",
      //   icon: "send",
      //   text: "Disparos",
      //   permission: true,
      //   group: ["admin", "customer_care"]
      // },
      // {
      //   to: "/cartoes",
      //   icon: "credit_card",
      //   text: "Cartões",
      //   permission: true,
      //   group: ["customer"]
      // },
      // {
      //   to: "/faturas",
      //   icon: "insert_chart_outlined",
      //   text: "Minhas Faturas",
      //   permission: true,
      //   group: ["customer"]
      // },
      /*
      {
        to: '/typography',
        icon: 'mdi-format-font',
        text: 'Typography'
      },
      {
        to: '/icons',
        icon: 'mdi-chart-bubble',
        text: 'Icons'
      },
      {
        to: '/maps',
        icon: 'mdi-map-marker',
        text: 'Maps'
      },
      {
        to: '/notifications',
        icon: 'mdi-bell',
        text: 'Notifications'
      }
      */
    ],
    responsive: false,
  }),
  computed: {
    ...mapState("app", ["image", "color"]),
    ...mapState(["user"]),

    inputValue: {
      get() {
        return this.$store.state.app.drawer;
      },
      set(val) {
        this.setDrawer(val);
      },
    },
    group() {
      return this.$store.getters.group;
    },
    items() {
      return this.$t("Layout.View.items");
    },

    activeLinks: function () {
      var vm = this;

      if (vm.user) {
        const group = vm.user.group;
        let isAdmin = false;
        if (Array.isArray(group)) isAdmin = group.indexOf("admin") >= 0; //ES6
        // if (group === "admin") {
        if (isAdmin) {
          return vm.links;
        } else {
          let l = false;
          // if(Array.isArray(group)) l = vm.links.some(r=> group.indexOf(r)) //ES6
          if (Array.isArray(group)) {
            l = vm.links.filter((link) => {
              return link.group.find((link1) => {
                return group.indexOf(link1) >= 0;
              });
            });
          } else {
            l = vm.links.filter((link) => {
              return link.group.find((link1) => {
                return link1 === group;
              });
            });
          }
          return l;
        }
      } else {
        return vm;
      }
    },
  },
  mounted() {
    this.partner = localStorage.getItem("partner") || "enercred";
    if (
      this.partner !== "enercred" &&
      this.partner !== "teste" &&
      this.partner !== "super" &&
      this.partner !== "localhost"
    ) {
      this.logo = "../../img/partner/" + this.partner + ".png";
    }
    // console.log('logo: ', this.logo)
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },
  methods: {
    ...mapMutations("app", ["setDrawer", "toggleDrawer"]),
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
    miniMenu(mini) {
      this.mini = mini;
      if (
        this.partner !== "enercred" &&
        this.partner !== "teste" &&
        this.partner !== "super" &&
        this.partner !== "localhost"
      ) {
        this.mini = false;
        this.logo = "../../img/partner/" + this.partner + ".png";
      } else {
        this.logo = this.mini
          ? "../../img/logo_novo_splash.png"
          : "../../img/enercred_branco_300.png";
      }
    },
    ...mapActions(["logout"]),
    signOut() {
      this.$store
        .dispatch("logout")
        .then(() => {
          localStorage.removeItem("user");
          this.$router.replace("/login");
        })
        .catch((error) => {
          console.error("Erro ao efetuar logout! ", error);
        });
      /*
      this.logout()
        .then(() => {
          localStorage.removeItem('user')
          this.$router.replace('/login')
        })
      */
    },
    goTo(url) {
      this.$router.push(url);
    },
  },
  watch: {
    $route(val) {
      if (val.meta.fullpage) {
        this.showDrawer = false;
      } else {
        this.showDrawer = true;
      }
    },
  },
};
</script>

<style lang="scss">
#app-drawer {
  .v-list__tile {
    border-radius: 4px;

    &--buy {
      margin-top: auto;
      margin-bottom: 17px;
    }
  }

  .v-image__image--contain {
    top: 9px;
    height: 60%;
  }

  .search-input {
    margin-bottom: 30px !important;
    padding-left: 15px;
    padding-right: 15px;
  }
}
</style>
